module.exports = __webpack_public_path__ + "static/img/victim-kids-4.6e1257f1.png";